<template>
    <div>
		<!--<complete-loading :pageloader_value="pageLoader" :type="'complete'" v-if="pageLoader"></complete-loading>-->	
		<div class="maxContainer tradingIdeas"> 
			<message-component :message="response_msg" :messageType="msg_type" v-if="response_msg != ''"></message-component>
			<div class="d-flex align-items-center justify-content-between">
				<div class="mainTitle text-center my-3">
					<h3>{{ $t('autocharist') }}</h3>
				</div> 
				<div class="searchData autochartistSearch position-relative">
		            <input type="text" class="form-control" placeholder="Search..." v-model="autosearch">
		            <button class="searchButton" type="button">
		                <feather type="search"></feather>
		            </button>
	            </div>
			</div>
			
			<div class="row"  >
			  <div class="col-4" v-for="list in autoChartist.records" v-if="autoChartist.totalRecords > 0 && !load_more_msz && searchauto(list.isin,autosearch)">
				<div class="card">
				  <div class="card-body"> 
					<h5 class="card-title">{{list.isin}} <sup v-if="list.side.toUpperCase()== 'BUY'" class="badge badge-pill badge-success">{{list.side}}</sup><sup class="badge badge-pill badge-danger" v-else>{{list.side}}</sup></h5>
			 
					<img v-if="imageLinkPortfolio+list.external_id+'&img='+list.media_file_title" :src="imageLinkPortfolio+list.external_id+'&img='+list.media_file_title" class="mb-3 card-img-top" :title='list.idea_title'/>
					<img v-else src="@/assets/trade_idea_default.png" class="mb-3 card-img-top" :title='list.idea_title'/>

					
					<h5 class="mb-3">{{list.idea_title}}</h5>
					<p class="card-text mb-3"> {{list.short_description}}</p>
					<div class="view-likes-block d-flex align-items-center justify-content-between">
					  <div class="currency-info d-flex align-items-center">
						<div class="currency mr-3">
						  {{list.isin}} <!-- {{list.}} -->
						</div>
						<span class="short">                                                           
						  <span class="badge badge-pill badge-success">{{list.holding_period}}</span>
						</span>
					  </div>
					  <div class="colRight d-flex align-items-center">
						<!--<div class="views d-flex align-items-center"><feather type="eye" class="mr-2"></feather> {{list.views}}</div>-->
						<div class="date d-flex align-items-center"><feather type="calendar" class="mr-2"></feather> {{list.date_created  | moment("DD MMMM YYYY")}}</div>
					  </div>
					</div> 
				  </div>
				</div>
			  </div> 
			  <div class="col-4" v-for="n in 3" v-if="pageLoader">
					<div class="card cardLoading"> 
						<h5 class="card__title loadingltr"></h5> 
						<div class="card__image loadingltr"></div>  
						<p class="card__description loadingltr mb-3"> </p>
						<div class="view-likes-block d-flex align-items-center justify-content-between">
							<div class="currency-info d-flex align-items-center">
								<div class="currency card__title loadingltr mr-3"></div>
								<span class="short">
								  <span class="badge badge-pill badge-success"></span>
								</span>
							</div>
							<div class="colRight card__title loadingltr d-flex align-items-center">
								<div class="views d-flex align-items-center"></div>
								<div class="date d-flex align-items-center"></div>
							</div>
						</div>  
					</div>
					 
				</div>
			</div>
			
			<div class="whiteBG border radiusbold p-5 mb-3 justify-content-between align-items-center d-flex" v-if="load_more_msz">
				<img src="../../../../static/fxView/images/manworking.svg" alt="live account" width="400" class="mr-5">
				<div class="lft">
					<h3 class="mb-4" v-html="$t('haveReachedFreeLimit')"></h3> 
					<span><router-link class="prism_btn btn_sm" to="/create-live-account">{{$t('CreateLiveAccount')}}</router-link></span> 
					<span><a href="#" class="prism_btn btn_sm darkBG ml-2" @click="load_more_msz = false">{{$t('Cancel')}}</a></span> 
				</div> 
			</div>  
			<div class="text-center pt-3  mb-3">
				<a href="#" class="prism_btn btn_sm mb-3" @click="load_more_msz = true"  v-if="parseInt(tradingAccountList.totalLiveAccounts) == 0 && !load_more_msz">{{$t('LoadMore')}}</a>
				<a href="#" class="prism_btn btn_sm mb-3" @click="loadList()" v-else-if="parseInt(tradingAccountList.totalLiveAccounts) > 0">{{$t('LoadMore')}}</a>
				<p> {{ $t('Poweredby') }} <a href="https://portfolios.com/" target="_blank"> {{ $t('PortfoliosCom') }}</a></p>
			</div> 
		</div>
		<div class="mb-2 text-center disclaimer darkBG p-3 row d-flex justify-content-center align-items-center">
			<div class="col-12 col-md-10">
				<small>{{$t('DisclaimerAutoChartist')}}</small>
			</div>
		</div>
    </div>
</template>
<script> 
	import { fxViewMixins } from '@/plugins/fxView'
	import { Const } from '@/plugins/fxView/provider/candle-history/lib/const.cls'
	export default {
		name: 'Auto-Chartist',
		mixins: [fxViewMixins],
		data() {
			return {
				//===========prop in loader component=======
				col_span : 5,
				load_more_msz : false,
				//============message and loader ===========
				response_msg : '',
				msg_type : '',
				pageLoader : false,
				loaderFuncRun : '1',
				//==========================================
				pageLimit : '15',
				search : '',
				page : 1,
				autosearch : ''
			}
		},
		methods:{
			loadList(){
				this.page = parseInt(this.page) + 1
				this.listing()
			},
			searchauto(searchdata,type){
                if(type == ''){
                  return true
                }else{
                  let searchVal = searchdata.toUpperCase();
                  let typeVal = type.toUpperCase();
                  return (searchVal.indexOf(typeVal) > -1)
                }
            },
			listing(){
				let inputJson = {
					'globalParams' : {
						filter: {},
						sort: [],
						search: this.search,
						page: this.page,
						perPage: parseInt(this.pageLimit),
					} ,'localParams' : {'parameter' : this , 'loaderFuncRun' : this.loaderFuncRun}
				}
				this._runGetAutochartistData(inputJson)
			}
		},
		created(){
			if(this.$store.getters[Const.GET_AUTO_CHARTIST] != ''){
				this.loaderFuncRun = '0'
			}
			this.listing()
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/fxView/tradingtools/autoChartist.vue